// extracted by mini-css-extract-plugin
export default {"AccountPage":"AccountPage_AccountPage__k0Jd7","header":"AccountPage_header__tnOG8","btn_logout":"AccountPage_btn_logout__U4evB","info":"AccountPage_info__ldcxA"};